import { client } from "service/service";

export const getRoles = async () => {
  try {
    const res = await client.get(`roles`);
    return res.data;
  } catch (err) {
    throw err;
  }
};

export const createRole = async (title: string, code: string, description: string) => {
  try {
    const res = await client.post(`roles`, { title, code, description });
    return res.data;
  } catch (err) {
    throw err;
  }
};

export const patchRole = async (id: string, title: string, code: string, description: string) => {
  try {
    const res = await client.patch(`roles/${id}`, { title, code, description });
    return res.data;
  } catch (err) {
    throw err;
  }
};

export const patchRolePermissions = async (id: string, documentId: string, subtargetId: string, permissionsValues: string[], permissionsAttachments: string[]) => {
  try {
    const res = await client.patch(`roles/${id}/permissions`, { documentId, subtargetId, permissionsValues, permissionsAttachments });
    return res.data;
  } catch (err) {
    throw err;
  }
}

export const deleteRole = async (id: string) => {
  try {
    const res = await client.delete(`roles/${id}`);;
    return res.data;
  } catch (err) {
    throw err;
  }
};
